import React from 'react';

export default function CloseSmall({color = '#666666'}: {color?: string}) {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect
                x='4'
                y='12.3076'
                width='11.7488'
                height='0.979063'
                rx='0.489531'
                transform='rotate(-45 4 12.3076)'
                fill={color}
            />
            <rect
                width='11.7488'
                height='0.979063'
                rx='0.489531'
                transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 13 12.3076)'
                fill={color}
            />
        </svg>
    );
}
